import type { Applet } from '../../classrooms-management/modules/applet/applet';

export const getCompletedActivities = (
  activities: Applet[] | null | undefined
): number => {
  if (!activities) {
    return 0;
  }

  return activities.filter((activity) => activity.completed).length;
};

export const getTotalActivities = (
  activities: Applet[] | null | undefined
): number => {
  return activities?.length || 0;
};
